import React from 'react'
import { Col, Nav, Row, Tab } from 'react-angle-dashboard-components'
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { LocationSearchField } from '../../LocationSearchField'
import { Location } from '../Directory'
import { InputPlaceholder, SearchContainer } from './style'

const InnerContainer = styled.div`
  max-width: 730px;
  width: 100%;
`

interface IDirectorySearchProps {
  selectLocation: (l: Location) => void
  title: string
  googlePlacesReady: boolean
}

export const DirectorySearch: React.FC<IDirectorySearchProps> = ({
  selectLocation,
  title,
  googlePlacesReady,
  ...p
}) => {
  const history = useHistory()
  const { path } = useRouteMatch()
  const urlSearchParams = new URLSearchParams(useLocation().search)

  const key = path.startsWith('/providers') ? 'providers' : 'facilities'

  const onSelect = (k: any) => {
    const params: any = {
      lat: urlSearchParams.get('lat'),
      lng: urlSearchParams.get('lng'),
      query: urlSearchParams.get('query')
    }

    const urlParams = `?${Object.keys(params)
      .filter((k) => Boolean(params[k]))
      .map((k) => `${k}=${params[k]}`)
      .join('&')}`

    history.push(`/${k}${urlParams}`)
  }
  return (
    <SearchContainer {...p}>
      <Row
        className="d-flex justify-content-between"
        style={{ position: 'relative', bottom: '0' }}
      >
        <Col xs="7" className="pr-0">
          <Tab.Container
            id="left-tabs-example"
            activeKey={key}
            onSelect={onSelect}
          >
            <section>
              <InnerContainer className="mx-auto">
                <Nav variant="tabs" className="border-bottom-0">
                  <Nav.Item className="mr-2">
                    <Nav.Link
                      className="pt-2 pb-2 mb-1 px-2"
                      eventKey="facilities"
                    >
                      <b>Facilities</b>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className="pt-2 pb-2 mb-1 px-2"
                      eventKey="providers"
                    >
                      <b>Providers</b>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </InnerContainer>
            </section>
          </Tab.Container>
        </Col>

        <Col className="pl-0">
          <div className="pt-1 text-right">
            {title === 'loading' ? 'Loading...' : <>{title}</>}
          </div>
        </Col>
      </Row>
      {googlePlacesReady ? (
        <LocationSearchField
          style={{ width: '100%', marginTop: '15px', marginBottom: '20px' }}
          onLocationSelected={selectLocation}
        />
      ) : (
        <InputPlaceholder />
      )}
    </SearchContainer>
  )
}

export default DirectorySearch
